import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURL = '/estructura-organizacional/estados-de-empleado/';

/**
 * GET Estados De Empleados
 * @param {object} params
 */
export const getEstadosDeEmpleados = async (params) => {
  try {
    const response = await API.get(baseURL, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
